import { createApp } from "vue";
import { createRouter, createWebHistory } from "vue-router";
import naive from "naive-ui";
import Root from "./Root.vue";
import Form from "./pages/Form.vue";
import Login from "./pages/Login.vue";
import CampaignsDashboard from "./pages/CampaignsDashboard.vue";
import { getAdminToken } from "./services/api";

const routes = [
  { path: "/login", component: Login, name: "login" },
  { path: "/form", component: Form, name: "form" },
  { path: "/dashboard", component: CampaignsDashboard, name: "dashboard" },
  { path: "/", redirect: "/dashboard" },
  // NOTE: /track/:campaignId/:strategyId is intentionally NOT a SPA route —
  // Firebase Hosting rewrites it straight to the `track` Cloud Function,
  // which 302-redirects the visitor without loading this app.
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to) => {
  if (to.name !== "login" && !getAdminToken()) {
    return { name: "login", query: { redirect: to.fullPath } };
  }
  return true;
});

const app = createApp(Root);
app.use(router);
app.use(naive);
app.mount("#app");
